module.exports = __webpack_public_path__ + "static/logo_footer-9b0ce5894fe615d66d8145193f139ea2.png";